import {Injectable, isDevMode} from '@angular/core';
import {catchError} from 'rxjs/internal/operators';
import {of, throwError} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';
import {HttpClient} from '@angular/common/http';
import {EventTrackingService} from './event-tracking.service';

@Injectable({
    providedIn: 'root'
})
export class WrenchApiService {

    public redirectUrl = "";

    constructor(protected http: HttpClient,
                protected authService: AuthService,
                protected router: Router,
                protected eventTrackingService: EventTrackingService) {
    }

    protected request(url: string, params: any, componentName: string, userEvent: any, basicAuth: boolean = false) {
        return this.http.post(
            this.authService.getBackendUrl(url),
            JSON.stringify(params),
            basicAuth ? this.authService.getBasicAuthHeaders() : this.authService.getAuthHeaders()
        ).pipe(
            catchError(err => {
                this.eventTrackingService.trackErrorEvent(componentName, "error", userEvent, url, params, err.responseCode);
                return this.handleError(err);
            }),
            mergeMap((resp: any) => {
                if (resp.responseCode === 100) {
                    this.eventTrackingService.trackSuccessEvent(componentName, "success", userEvent, url, params, resp.responseCode);
                    return of(resp);
                } else if (resp.responseCode === 101) {
                    this.eventTrackingService.trackSuccessEvent(componentName, "partial success", userEvent, url, params, resp.responseCode);
                    return of(resp);
                } else {
                    this.eventTrackingService.trackErrorEvent(componentName, "error", userEvent, url, params, resp.responseCode);
                    return throwError(resp);
                }
            })
        );
    } // request()

    protected handleError(error: any) {
        // check for login and activate account to prevent endless loop
        if (document.location.pathname &&
            document.location.pathname != '/login' &&
            document.location.pathname != '/activateaccount') {
            this.redirectUrl = document.location.pathname;
        }

        // check for http 403 or 401 or 420 error
        if (error.status == 403 || error.status == 401) {
            if (!isDevMode) {
                this.router.navigate(['/login']);
            } else {
                console.log(403);
            }
        } else if (error.status == 420) {
            this.router.navigate(['/activateaccount']);
        }

        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return throwError(errMsg);

    } // handleError()
}
